import { Injectable } from '@angular/core';
import { BookingParamsState } from '../../../states/booking-params-state/booking-params.state';
import { Select, Store } from '@ngxs/store';
import { IBookingParams } from '../../interfaces/booking-params';
import { Observable } from 'rxjs';
import { AddBookingParams } from '../../../actions/booking-params-action/booking-params.action';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from '../breadcrumbs/breadcrumbs.service';

@Injectable()
export class BookingParamsService {
  @Select(BookingParamsState.getBookingParams) getBookingParams: Observable<IBookingParams>;

  constructor(
    private readonly store: Store,
    private readonly breadcrumbsService: BreadcrumbsService,
    public router: Router
  ) {}

  dispatchAddBookingParams(
    params: IBookingParams,
    others?: object,
    activatedRoute?: ActivatedRoute,
    currentRouteParams?: object,
    isBookingWidget?: boolean
  ): void {
    this.store.dispatch(new AddBookingParams(params)).subscribe((params) => {
      // @ts-expect-error params is reported as "void", but it's most likely not
      if (params.bookingParams['bookingParams']) {
        if (isBookingWidget) {
          this.updateUrl(others, activatedRoute, currentRouteParams);
        } else {
          // @ts-expect-error params is reported as "void", but it's most likely not
          this.updateBreadcrumbsParams(params.bookingParams['bookingParams']);
        }
      }
    });
  }
  selectBookingParams(): Observable<IBookingParams> {
    return this.getBookingParams;
  }
  updateUrl(others: object, activatedRoute: ActivatedRoute, currentRouteParams: object) {
    this.router.navigate([], {
      queryParams: others,
      relativeTo: activatedRoute,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });

    setTimeout(() => {
      // url parameters in breadcrumbs: merge the current and the new ones
      this.updateBreadcrumbsParams({ ...currentRouteParams, ...others });
    }, 0);
  }
  updateBreadcrumbsParams(params: object) {
    this.breadcrumbsService.setBreadcrumbsParamsFromLocation(params);
  }
}
